module.exports = __webpack_public_path__ + "static/img/test-their-knowledge.8baddeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/test-their-knowledge.png
// module id = dYpY
// module chunks = 0